import { SphereDropdownMenuItem } from "@components/common/dropdown/sphere-dropdown-selector-item";
import { Menu } from "@flat-ui";
import { DEBOUNCE_DELAY_MS, useDebouncedCallback } from "@hooks/use-debounce-callback";
import { Box, Fade, Stack } from "@mui-wrapper";
import { useMemo, useState, useRef } from "react";

/** MAX menu height and create scroll after that */
const MENU_MAX_HEIGHT = 250;

/** Renders a dropdown with selectable items */
export function SphereDropdownSelector({
  items,
  currentValue,
  handleChange,
  defaultLabel,
  menuPosition,
  renderButton
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);
  const isOpen = Boolean(anchorEl);
  const debouncedHandleChange = useDebouncedCallback(handleChange, DEBOUNCE_DELAY_MS, {
    edges: ["leading"]
  });
  const currentValueLabel = useMemo(() => {
    const currentValueItem = items.find(item => item.value === currentValue);
    return currentValueItem?.label;
  }, [currentValue, items]);
  function onValueChange(value) {
    debouncedHandleChange(value);
    setAnchorEl(null);
  }
  function handleOpen() {
    if (buttonRef.current) {
      setAnchorEl(isOpen ? null : buttonRef.current);
    }
  }
  const label = currentValueLabel || defaultLabel;
  return <Stack sx={{
    height: "100%",
    justifyContent: "center"
  }}>
      <Box ref={buttonRef}>
        {renderButton({
        isOpen,
        onClick: handleOpen,
        label
      })}
      </Box>

      <Menu anchorEl={anchorEl} open={isOpen} onClose={() => {
      debouncedHandleChange.cancel();
      setAnchorEl(null);
    }} anchorOrigin={menuPosition?.anchorOrigin ?? {
      vertical: "bottom",
      horizontal: "right"
    }} transformOrigin={menuPosition?.transformOrigin ?? {
      vertical: "top",
      horizontal: "right"
    }} minWidth="7.875rem" slotProps={{
      paper: {
        sx: {
          maxHeight: MENU_MAX_HEIGHT,
          overflowY: "auto"
        }
      }
    }} slots={{
      transition: Fade
    }}>
        {items.map(item_0 => <SphereDropdownMenuItem key={item_0.value} item={item_0} currentValue={currentValue} handleChange={onValueChange} />)}
      </Menu>
    </Stack>;
}